var React = require('react');

function Dev (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.64 11.77 3.56 16l5.08 4.23a1 1 0 1 1-1.28 1.54l-6-5a1 1 0 0 1 0-1.54l6-5a1 1 0 1 1 1.28 1.54Zm22 3.46-6-5a1 1 0 1 0-1.28 1.54L28.44 16l-5.08 4.23a1 1 0 1 0 1.28 1.54l6-5a1 1 0 0 0 0-1.54ZM20.34 4.06a1 1 0 0 0-1.28.6l-8 22a1 1 0 1 0 1.88.68l8-22a1 1 0 0 0-.6-1.28Z"}));
}

Dev.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Dev;

Dev.default = Dev;
